import { render, staticRenderFns } from "./core-string-html-block-edit.vue?vue&type=template&id=f10bcf4a&"
import script from "./core-string-html-block-edit.vue?vue&type=script&lang=js&"
export * from "./core-string-html-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports